@if (noDocument) {
<div>
  <div class="text-center text-red-500">
    <br />
    <br />
    <div>Documento no encontrado.</div>
  </div>
</div>
} @if (!noDocument && !pdfBase64) {
<div class="loader-container">
  <div class="mt-10 text-center">
    <br />
    <br />
    <div>Cargando Documento, Espere...</div>
  </div>
</div>
} @if (pdfBase64) {
<div class="pdf-container">
  <embed [src]="pdfBase64" type="application/pdf" width="100%" height="100%" />
</div>
}
